import React, { useState, useEffect, useRef } from "react";
import {
  ArrowRight, ChevronLeft, ChevronRight, Play, X, Check, MapPin, Calendar, Clock,
  Building2, Users, Globe, DollarSign, Briefcase, Download, ChevronDown, Instagram,
  Target, Mic, Search, Lightbulb, Rocket, GraduationCap, Sparkles,
} from "lucide-react";
import SharedFooter from "../components/SharedFooter";

const BOWER_LOGO = "https://bowerschool.com/logo-final.png";
const HERO_BG = "https://bowerschool.com/3dc1071e232fc496d7f837f04f1cd533a8eb0275.png";
const BREAKUP_CIRCLE = "https://bowerschool.com/ug-brakeup-circle.png";
const VIDEO_POSTER = "https://bowerschool.com/0f5c2de88b037fbd74098685159fdd28675733c0.png";
// Video URL — placeholder; user can swap with actual asset later.
const VIDEO_YT_ID = "c7hHUf4uCz4";

const ZOHO_ACTION = "https://forms.zohopublic.in/bowereducationalservicespriv1/form/UGBBAProgramJuly26IntakeInterestForm/formperma/O3wWO0bnfR5UqVY-R_A9SHcyaB1S1FABaEffmOwz1UE/htmlRecords/submit";
const REFERRER = "UG_Landingpage";

const STATES = {
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Tirupati"],
  "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur"],
  "Chandigarh": ["Chandigarh"],
  "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur"],
  "Delhi": ["New Delhi", "South Delhi", "North Delhi", "East Delhi", "West Delhi"],
  "Goa": ["Panaji", "Margao", "Vasco da Gama"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
  "Haryana": ["Gurugram", "Faridabad", "Panipat", "Ambala", "Sonipat"],
  "Jammu and Kashmir": ["Srinagar", "Jammu"],
  "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad"],
  "Karnataka": ["Bengaluru", "Mysuru", "Mangaluru", "Hubli"],
  "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior"],
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik"],
  "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela"],
  "Punjab": ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Mohali"],
  "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Salem"],
  "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Noida", "Ghaziabad"],
  "Uttarakhand": ["Dehradun", "Haridwar", "Roorkee"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri"],
};

const COUNTRY_CODES = [
  { code: "+91", flag: "🇮🇳" },
  { code: "+1", flag: "🇺🇸" },
  { code: "+44", flag: "🇬🇧" },
  { code: "+971", flag: "🇦🇪" },
  { code: "+65", flag: "🇸🇬" },
  { code: "+61", flag: "🇦🇺" },
];

const MENTORS = [
  { name: "Mr. Ajit Rangnekar", role: "Ex-Dean, ISB", img: "https://bowerschool.com/cfae23ad21417d90754e983d0204f99238879016%20copy.png" },
  { name: "Mr. Srinivas Rao Mahankali (MSR)", role: "Ex-CEO, T-Hub", img: "https://bowerschool.com/0ba33ba7ced8b9178013060ee221d1e4c9de820c%20copy.png" },
  { name: "Ms. Asha Latha", role: "Ex-Director, Faculty Alignment & Registrar Office - ISB", img: "https://bowerschool.com/dec6e7f34ecf37e9340fd7c6b776985781ddaf3c%20copy.png" },
  { name: "Dr Nagendra V. Chowdary", role: "Chief Education Officer, The ICFAI Group", img: "https://bowerschool.com/382f160863b69acae436195b40bb85da0c66de4e.png" },
  { name: "Mr. Praveen Garimella", role: "Imagineering Education", img: "https://bowerschool.com/4df818fb23c1bdff0874926744198693013b90c2.png" },
  { name: "Mr. Munwar Khan", role: "Head of Design, OPPO", img: "https://bowerschool.com/7e0dd31e5216e946892f041b4d3b8a6699bf0017.png" },
  { name: "Mr. Ajay Jain", role: "Co-Founder, Silverneedle Ventures", img: "https://bowerschool.com/9dceceaf0fb3eb2996f109618aa7bdec5cb4cc3b.png" },
  { name: "Mr. Abhinav Chaturvedi", role: "Marketing Leader, Ex-Facebook", img: "https://bowerschool.com/a703df950c9845faabd811b3c00b90338e95129a.png" },
];

const WHY_BOWER = [
  { title: "Bower Campus", desc: "Powerhouse of ideas in the Tech park where top practitioners, academicians, and founders meet to innovate.", icon: Building2, tilt: -3 },
  { title: "Exclusive Access to CXOs & Mentors", desc: "Tailored mentorship from Top Entrepreneurs, Venture Capitalists and Industry Experts.", icon: Users, tilt: 2 },
  { title: "Global Exposure", desc: "Participate in international accelerators, competitions, and study programs.", icon: Globe, tilt: -2 },
  { title: "B-CAPITAL", desc: "Bower fund fast-tracks top startups to funding and market success.", icon: DollarSign, tilt: 2 },
  { title: "Bower Perch", desc: "A platform connecting students and startups. You get to be on both sides of the table: interning and recruiting interns!", icon: Briefcase, tilt: -1 },
];

const CURRICULUM_COMPARISON = [
  { old: { title: "From text-book driven learning", desc: "Emphasis on rote memorization, standard subjects, and exams." }, bower: { title: "To Real-World Learning", desc: "Hands-on projects that connect concepts to real challenges." } },
  { old: { title: "From Limited Exposure", desc: "Ideas are limited to classrooms and knowledge is gained, not applied." }, bower: { title: "To Learning Life Skills", desc: "Entrepreneurship, design thinking, and financial literacy from an early age." } },
  { old: { title: "From One-Size-Fits-All Curriculum", desc: "Same content for every student, regardless of interests or aspirations." }, bower: { title: "To Tailored Learning Paths", desc: "Age-appropriate, modular content that evolves as students grow." } },
  { old: { title: "From Teacher-Centric Classrooms", desc: "Students are passive recipients of information." }, bower: { title: "To Student-Led Exploration", desc: "Students design, discover and do." } },
  { old: { title: "From Minimal Industry Exposure", desc: "Little interaction with real-world professionals or problems." }, bower: { title: "To Expert Mentorship & Immersion", desc: "Sessions led by entrepreneurs and innovators." } },
  { old: { title: "From Short-Term Academic Focus", desc: "Emphasis on grades over long-term thinking." }, bower: { title: "To Mindset for the Future", desc: "Builds creativity, resilience, and a problem-solving attitude for life." } },
];

const STATS = [
  { value: "92%", title: "Students Build Real-World Projects", desc: "From concept to prototype, most Bower students launch at least one project during their journey." },
  { value: "45+", title: "Industry Mentors Across Domains", desc: "Our mentors include founders, CXOs, and investors guiding students in every step of the way." },
  { value: "3x", title: "More Presentations Than Traditional Programs", desc: "Students regularly pitch, collaborate, and present — building communication skills." },
];

const YEAR_CURRICULUM = [
  {
    year: "Year 1",
    title: "Foundation of Entrepreneurship",
    semesters: [
      {
        name: "Semester 1",
        blocks: [
          { title: "Discipline Specific Module", items: ["Entrepreneurship Theory and Practice", "Business Innovation Fundamentals", "Micro and Macro Economics", "Entrepreneurial Economics", "Basics of Financial Accounting", "Fundamentals of Marketing", "Design Thinking"] },
          { title: "Ability Enhancement Module", items: ["Coding Fundamentals", "Foundation of Statistics"] },
          { title: "Skill Enhancement Module", items: ["Professional English for Entrepreneurs", "Digital Literacy & Online Research Skills"] },
          { title: "Value Added Module", items: ["Financial Literacy and Investment Planning", "Mindfulness and Mental Resilience for Founders", "Indian Constitution"] },
          { title: "Practical", items: ["IGNITE — Startup Lab 360: Experiencing the Life of a Founder"] },
        ],
      },
      {
        name: "Semester 2",
        blocks: [
          { title: "Discipline Specific Module", items: ["Managerial Accounting", "Decision-Making with Accounting Information", "Budgeting and Forecasting", "Foundational Financial Management for Startups", "Personal Wealth & Capital Management", "Introduction to AI/ML in Business", "AI Applications in Customer Insights & Business Models"] },
          { title: "Value Added Module", items: ["Foundational Logical & Critical Reasoning", "Ethics, Bias & Responsible AI in Entrepreneurship", "Decision-Making in the Age of AI"] },
          { title: "Ability Enhancement Module", items: ["Designing with Figma for Entrepreneurs", "Excel for Budgeting and Forecasting"] },
          { title: "Skill Enhancement Module", items: ["Business Communication"] },
          { title: "Practical", items: ["Venture Creation: Validate, Build, Acquire Customers"] },
        ],
      },
    ],
  },
  {
    year: "Year 2",
    title: "Building Your Venture",
    semesters: [
      {
        name: "Semester 3",
        blocks: [
          { title: "Discipline Specific Module", items: ["Product Management for Founders", "Growth Marketing & Digital Distribution", "Operations & Supply Chain for Startups", "Human Resource Management for Small Teams", "Business Law & IP for Entrepreneurs"] },
          { title: "Ability Enhancement Module", items: ["Data Analytics for Business Decisions", "No-Code / Low-Code Building"] },
          { title: "Practical", items: ["Venture Build Sprint I — MVP to Market"] },
        ],
      },
      {
        name: "Semester 4",
        blocks: [
          { title: "Discipline Specific Module", items: ["Fundraising, Term Sheets & Cap Tables", "Sales & Business Development", "Customer Success & Retention", "Brand Building & Storytelling"] },
          { title: "Ability Enhancement Module", items: ["Financial Modeling", "Startup Metrics & Analytics"] },
          { title: "Practical", items: ["Venture Build Sprint II — Scaling & Traction"] },
        ],
      },
    ],
  },
  {
    year: "Year 3",
    title: "Scaling & Launch",
    semesters: [
      {
        name: "Semester 5",
        blocks: [
          { title: "Discipline Specific Module", items: ["Advanced Strategy for Founders", "Global Markets & Cross-Border Entrepreneurship", "M&A, Exits and Corporate Development", "Impact & Sustainability for New Ventures"] },
          { title: "Ability Enhancement Module", items: ["Investor Relations", "Advanced Financial Modeling"] },
          { title: "Practical", items: ["Founder Residency I — Live Venture at Bower Incubator"] },
        ],
      },
      {
        name: "Semester 6",
        blocks: [
          { title: "Discipline Specific Module", items: ["Capstone Venture Project", "Advanced Leadership & Team Building", "Public Speaking & Investor Pitching"] },
          { title: "Practical", items: ["Founder Residency II — Demo Day, Pitch & Deploy"] },
        ],
      },
    ],
  },
];

const FOUNDER_STATS = [
  { value: "92%", label: "Practitioner-led Teaching" },
  { value: "3000", label: "Hours of Learning" },
  { value: "100+", label: "Mentors Associated" },
];

const FOUNDER_SKILLS = [
  { icon: Target, title: "Strategic Thinking", desc: "Learn to define your market, craft winning business models, and plan for growth." },
  { icon: Mic, title: "Pitching & Storytelling", desc: "Master the art of communicating your vision to investors and customers." },
  { icon: Search, title: "Opportunity Sensing", desc: "Sharpen your instincts to spot scalable ideas, untapped markets, and businesses with high growth potential." },
  { icon: Lightbulb, title: "Customer Intelligence", desc: "Understand customers deeply — behaviour, needs, and buying triggers — to build products that truly resonate." },
  { icon: Rocket, title: "Leadership in Action", desc: "Build confidence to lead teams, make decisions under pressure, and navigate entrepreneurial uncertainty." },
];

const TOOLS = [
  { name: "Google Workspace", img: "https://bowerschool.com/tools/google-icon-small.png" },
  { name: "Microsoft Excel", img: "https://bowerschool.com/tools/excel-logo.png" },
  { name: "Notion", img: "https://bowerschool.com/tools/notion-logo.png" },
  { name: "Canva", img: "https://bowerschool.com/tools/canva-logo.png" },
  { name: "Power BI", img: "https://bowerschool.com/tools/power-bi-logo.png" },
  { name: "Python", img: "https://bowerschool.com/tools/python-logo.png" },
  { name: "Tableau", img: "https://bowerschool.com/tools/tablo-logo.png" },
  { name: "R", img: "https://bowerschool.com/tools/r-language-logo.png" },
  { name: "SQL", img: "https://bowerschool.com/tools/sql-logo.png" },
  { name: "GitHub", img: "https://bowerschool.com/tools/git-hub-logo.png" },
  { name: "Slack", img: "https://bowerschool.com/tools/slack-icon.png" },
  { name: "Figma", img: "https://bowerschool.com/tools/figma-logo.png" },
  { name: "Bubble.io", img: "https://bowerschool.com/tools/bubble-logo.png" },
  { name: "Webflow", img: "https://bowerschool.com/tools/web-flow-logo.png" },
  { name: "AWS", img: "https://bowerschool.com/tools/aws-logo.png" },
  { name: "Azure", img: "https://bowerschool.com/tools/cloud-logo.png" },
  { name: "Google Analytics", img: "https://bowerschool.com/tools/google-anlytics-logo.png" },
  { name: "ChatGPT", img: "https://bowerschool.com/tools/chat-gpt.png" },
  { name: "Salesforce", img: "https://bowerschool.com/tools/sf-logo.png" },
  { name: "Discord", img: "https://bowerschool.com/tools/discord-logo.png" },
  { name: "Trello", img: "https://bowerschool.com/tools/trello-logo.png" },
  { name: "QuickBooks", img: "https://bowerschool.com/tools/quick-books-logo.png" },
  { name: "Zoho Suite", img: "https://bowerschool.com/tools/zoho-suite.png" },
];

const GLIMPSE_IMAGES = [
  "https://bowerschool.com/images/ug/2.png",
  "https://bowerschool.com/4d58bfa8ac7c44f2096a57a33f93a3274ae1fab7.png",
  "https://bowerschool.com/images/ug/7.png",
  "https://bowerschool.com/6ed276279ae9cdc4456710f0b73bb1a5b0373190.png",
  "https://bowerschool.com/images/ug/4.png",
  "https://bowerschool.com/b2870026332143c8f0222a6adccd3c9bc932e99a.png",
  "https://bowerschool.com/9969d98f553cfdd4f54ff0528d9b873c3571090b.png",
  "https://bowerschool.com/images/ug/8.png",
  "https://bowerschool.com/a2ff0f314850b98ca460a61a3fdaf1cf88eaadaa.png",
  "https://bowerschool.com/86d7d0c6a38f76a2ea9dec7b9524326b3c628eff.png",
];

const STUDENT_VENTURES = [
  { name: "Krittik Vemuri", role: "UG Student", img: "https://bowerschool.com/cc8bd337331e6baf40244272de98d9327dcb7be8.png", quote: "Building Tycho has been an incredible journey. The mentorship and resources at Bower helped me turn my spacetech idea into reality — we're now developing independent satellite propulsion systems and space tugs that could revolutionize space logistics." },
  { name: "Kirti Vemuri", role: "UG Student", img: "https://bowerschool.com/9378498a88d316d5d00b48b4126cd75924de73ce.png", quote: "ShortList started as a simple idea to democratize the entertainment industry. With Bower's guidance, we're now building a platform that gives aspiring talent real access to opportunities, breaking down traditional barriers in the industry." },
  { name: "Aaryan Valluri", role: "UG Student", img: "https://bowerschool.com/79763e94e3cf0b3aa13a6d6d82275479e5f6d562.png", quote: "PropEase is solving real problems I've seen in the rental market. The practical business skills and technical knowledge from Bower helped me create a platform that efficiently connects property owners and tenants, streamlining resource management." },
];

const APPLICATION_ROUNDS = [
  { round: "Round 1", deadline: "January 16, 2026", start: "August 2026", status: "Closed" },
  { round: "Round 2", deadline: "February 15, 2026", start: "August 2026", status: "Closed" },
  { round: "Round 3", deadline: "July 19, 2026", start: "August 2026", status: "Apply now" },
];

const APPLICATION_STEPS = [
  { title: "Begin Your Bower Journey", desc: "Applicants complete the online application form to express their interest and share key information." },
  { title: "Take the BEAT Test", desc: "The Bower Entrepreneurial Aptitude Test is designed to spot entrepreneurial potential. Take the test and become eligible for one of Bower's seven exclusive scholarships." },
  { title: "Connect with an Advisor", desc: "All applicants are encouraged to schedule a one-on-one conversation to discuss their goals, understand the program, and explore scholarship opportunities." },
  { title: "Receive Admission Offer", desc: "Candidates who receive an offer get set to join the Bower community — a dynamic network of future founders, innovators, and leaders-in-the-making." },
];

const FEE_STRUCTURE = [
  { year: "Admission Fee", fee: "INR 1,18,000" },
  { year: "Year 1", fee: "INR 7,61,100" },
  { year: "Year 2", fee: "INR 8,31,900" },
  { year: "Year 3", fee: "INR 9,09,780" },
];
const FEE_TOTAL = { year: "Total", fee: "INR 26,20,780" };

const FAQ_CATEGORIES = [
  {
    name: "General",
    items: [
      { q: "Who is eligible to apply for the Bower UG BBA?", a: "The 3-year BBA in Entrepreneurship is designed for students aged 17–20 who have completed (or are completing) Class 12 in any stream — Science, Commerce, Arts/Humanities — from ICSE, CBSE, IB, State Board, CAIE or NIOS boards." },
      { q: "Where is Bower's UG campus located?", a: "The Bower campus is located in the Tech Park in Hyderabad, India — a hub where practitioners, academicians, investors and founders come together to build." },
      { q: "Is Bower's degree UGC recognised?", a: "The BBA is awarded by our academic partner university and is fully UGC-recognised. Bower delivers the practitioner-led entrepreneurship curriculum and mentor network on top." },
    ],
  },
  {
    name: "Eligibility",
    items: [
      { q: "Do I need prior business or coding experience?", a: "No prior business or coding experience is required. The curriculum starts from first principles and layers up rapidly with practical modules." },
      { q: "What if I'm from a Science / non-Commerce background?", a: "Absolutely welcome. Our cohorts are intentionally cross-disciplinary — Science, Commerce and Arts students bring different lenses to entrepreneurship." },
    ],
  },
  {
    name: "Admissions",
    items: [
      { q: "How do I apply?", a: "Fill the interest form on this page, take the BEAT (Bower Entrepreneurial Aptitude Test), and then have a 1:1 conversation with an admissions advisor. Shortlisted candidates receive an offer." },
      { q: "When does the next cohort start?", a: "The August 2026 cohort begins in the first week of August 2026. Round 3 deadline is July 19, 2026." },
      { q: "How many rounds are there?", a: "There are 3 admission rounds each year. Rounds 1 and 2 are currently closed. Round 3 is open." },
    ],
  },
  {
    name: "Fees / Refund",
    items: [
      { q: "What is the total program fee?", a: "The total 3-year program fee is INR 26,20,780 including a one-time admission fee of INR 1,18,000. Detailed breakup is in the Fee Structure section above." },
      { q: "Are scholarships available?", a: "Yes — Bower offers 7 exclusive scholarship categories. Every BEAT test taker is automatically considered for scholarship eligibility." },
      { q: "What is the refund policy?", a: "Please refer to bowerschool.com/refund-policy for the full refund policy applicable to each round." },
    ],
  },
];

// Lightweight scroll-reveal wrapper using IntersectionObserver.
function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setShown(true); io.disconnect(); } },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: shown ? 1 : 0,
        transform: shown ? "translateY(0)" : "translateY(24px)",
        transition: `opacity 700ms ease ${delay}ms, transform 700ms ease ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

// Interest form (right column of hero) — Zoho hidden POST + FastAPI fallback.
function InterestForm() {
  const [state, setState] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const zohoFormRef = useRef(null);

  useEffect(() => {
    setCityOptions(state ? (STATES[state] || []) : []);
  }, [state]);

  const validate = (v) => {
    const e = {};
    if (!v.firstName.trim()) e.firstName = "Required";
    if (!v.lastName.trim()) e.lastName = "Required";
    if (!/^\d{10}$/.test(v.phone.replace(/\D/g, ""))) e.phone = v.phone.trim() ? "Enter 10-digit number" : "Required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) e.email = v.email.trim() ? "Invalid email" : "Required";
    if (!v.schoolName.trim()) e.schoolName = "Required";
    if (!v.state) e.state = "Required";
    if (!v.city) e.city = "Required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const v = Object.fromEntries(fd.entries());
    if (!validate(v)) return;

    setSubmitting(true);
    const params = new URLSearchParams(window.location.search);
    const zoho = zohoFormRef.current;
    const set = (name, val) => {
      const el = zoho.querySelector(`[name="${name}"]`);
      if (el) el.value = val;
    };
    set("Name_First", v.firstName);
    set("Name_Last", v.lastName);
    set("PhoneNumber_countrycodeval", v.countryCode);
    set("PhoneNumber_countrycode", v.phone.replace(/\D/g, ""));
    set("Email", v.email);
    set("SingleLine", v.schoolName);
    set("Address_Region", v.state);
    set("Address_City", v.city);
    set("Dropdown2", v.grade || "-Select-");
    set("Dropdown3", v.stream || "-Select-");
    set("Dropdown4", v.board || "-Select-");
    const decisionEl = zoho.querySelector('[name="DecisionBox"]');
    if (decisionEl) decisionEl.checked = v.whatsapp === "on";
    set("utm_source", params.get("utm_source") || "");
    set("utm_medium", params.get("utm_medium") || "");
    set("utm_campaign", params.get("utm_campaign") || "");
    set("utm_term", params.get("utm_term") || "");
    set("utm_content", params.get("utm_content") || "");
    set("zf_referrer_name", REFERRER);
    zoho.submit();

    // Backend fallback (fire and forget)
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/leads`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        first_name: v.firstName, last_name: v.lastName,
        phone: v.countryCode + v.phone.replace(/\D/g, ""),
        email: v.email, school_name: v.schoolName, state: v.state, city: v.city,
        grade: v.grade, stream: v.stream, board: v.board, referrer_name: REFERRER,
        utm_source: params.get("utm_source") || "", utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "", utm_term: params.get("utm_term") || "",
        utm_content: params.get("utm_content") || "",
      }),
    }).catch(() => {});

    setTimeout(() => {
      setSubmitted(true);
      setSubmitting(false);
      if (window.fbq) window.fbq("track", "Lead", { content_name: "UG Program Interest" });
      // Scroll the success card into view so users see the confirmation
      setTimeout(() => {
        const el = document.getElementById("ug-form");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    }, 1300);
  };

  const errText = (k) => errors[k] ? <p className="text-[11px] text-rose-600 mt-1">{errors[k]}</p> : null;
  const inputCls = (k) =>
    `w-full min-w-0 box-border px-3 py-2.5 text-sm text-slate-900 bg-white border-[1.5px] rounded-lg outline-none transition placeholder:text-slate-400 focus:border-[#4242FF] focus:shadow-[0_0_0_3px_rgba(66,66,255,0.12)] ${errors[k] ? "border-rose-400" : "border-slate-200"}`;

  return (
    <div id="ug-form" className="bg-[#f5f6ff] border border-[rgba(66,66,255,0.4)] shadow-[8px_8px_24px_0_rgba(66,66,255,0.12)] rounded-2xl p-5 md:p-7 max-w-[560px] mx-auto lg:mx-0 lg:ml-auto min-w-0" data-testid="ug-form-card">
      <iframe name="ug_zoho_frame" title="Zoho Submit Target" className="absolute w-0 h-0 border-0 overflow-hidden" tabIndex={-1} />
      <form ref={zohoFormRef} id="ugf-zoho" method="POST" target="ug_zoho_frame" acceptCharset="UTF-8" encType="multipart/form-data" action={ZOHO_ACTION} className="absolute w-0 h-0 overflow-hidden" tabIndex={-1}>
        <input type="hidden" name="zf_referrer_name" defaultValue="" />
        <input type="hidden" name="zf_redirect_url" defaultValue="" />
        <input type="hidden" name="zc_gad" defaultValue="" />
        <input type="hidden" name="utm_source" defaultValue="" />
        <input type="hidden" name="utm_medium" defaultValue="" />
        <input type="hidden" name="utm_campaign" defaultValue="" />
        <input type="hidden" name="utm_term" defaultValue="" />
        <input type="hidden" name="utm_content" defaultValue="" />
        <input type="hidden" name="Name_First" defaultValue="" />
        <input type="hidden" name="Name_Last" defaultValue="" />
        <input type="hidden" name="PhoneNumber_countrycodeval" defaultValue="" />
        <input type="hidden" name="PhoneNumber_countrycode" defaultValue="" />
        <input type="hidden" name="Email" defaultValue="" />
        <input type="hidden" name="SingleLine" defaultValue="" />
        <input type="hidden" name="Address_Region" defaultValue="" />
        <input type="hidden" name="Address_City" defaultValue="" />
        <input type="hidden" name="Dropdown2" defaultValue="-Select-" />
        <input type="hidden" name="Dropdown3" defaultValue="-Select-" />
        <input type="hidden" name="Dropdown4" defaultValue="-Select-" />
        <input type="checkbox" name="DecisionBox" defaultChecked={false} />
      </form>

      {!submitted ? (
        <>
          <h3 className="text-[22px] font-bold text-[#1a2555] tracking-[-0.6px] mb-1">Interested in the UG Program?</h3>
          <p className="text-[13px] text-[#6a6a6a] mb-4 leading-relaxed">Share your details and our admissions team will reach out with program &amp; scholarship information.</p>
          <form onSubmit={onSubmit} noValidate data-testid="ug-interest-form">
            <div className="grid grid-cols-2 gap-2.5 mb-2.5">
              <div className="min-w-0">
                <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">First Name <span className="text-rose-600">*</span></label>
                <input name="firstName" type="text" placeholder="First name" className={inputCls("firstName")} data-testid="ug-input-first-name" />
                {errText("firstName")}
              </div>
              <div className="min-w-0">
                <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">Last Name <span className="text-rose-600">*</span></label>
                <input name="lastName" type="text" placeholder="Last name" className={inputCls("lastName")} data-testid="ug-input-last-name" />
                {errText("lastName")}
              </div>
            </div>
            <div className="mb-2.5">
              <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">Phone <span className="text-rose-600">*</span></label>
              <div className="flex gap-2 items-stretch">
                <select name="countryCode" defaultValue="+91" className="w-[92px] flex-shrink-0 px-2 py-2.5 text-sm bg-white border-[1.5px] border-slate-200 rounded-lg" data-testid="ug-select-country-code">
                  {COUNTRY_CODES.map((c) => <option key={c.code} value={c.code}>{c.flag} {c.code}</option>)}
                </select>
                <input name="phone" type="tel" placeholder="10-digit mobile" className={`flex-1 ${inputCls("phone")}`} data-testid="ug-input-phone" />
              </div>
              {errText("phone")}
            </div>
            <div className="mb-2.5">
              <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">Email <span className="text-rose-600">*</span></label>
              <input name="email" type="email" placeholder="your@email.com" className={inputCls("email")} data-testid="ug-input-email" />
              {errText("email")}
            </div>
            <div className="mb-2.5">
              <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">School Name <span className="text-rose-600">*</span></label>
              <input name="schoolName" type="text" placeholder="Your school name" className={inputCls("schoolName")} data-testid="ug-input-school" />
              {errText("schoolName")}
            </div>
            <div className="grid grid-cols-2 gap-2.5 mb-2.5">
              <div className="min-w-0">
                <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">State <span className="text-rose-600">*</span></label>
                <select name="state" value={state} onChange={(e) => setState(e.target.value)} className={inputCls("state")} data-testid="ug-select-state">
                  <option value="">Select State</option>
                  {Object.keys(STATES).sort().map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                {errText("state")}
              </div>
              <div className="min-w-0">
                <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">City <span className="text-rose-600">*</span></label>
                <select name="city" disabled={!state} className={inputCls("city")} data-testid="ug-select-city">
                  <option value="">{state ? "Select City" : "Select State First"}</option>
                  {cityOptions.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
                {errText("city")}
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2.5 mb-3">
              <div className="min-w-0">
                <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">Grade</label>
                <select name="grade" className={inputCls("grade")} data-testid="ug-select-grade">
                  <option value="">Select</option>
                  <option>Grade 11</option>
                  <option>Grade 12</option>
                </select>
              </div>
              <div className="min-w-0">
                <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">Stream</label>
                <select name="stream" className={inputCls("stream")} data-testid="ug-select-stream">
                  <option value="">Select</option>
                  <option>Science</option>
                  <option>Commerce</option>
                  <option>Arts/Humanities</option>
                </select>
              </div>
              <div className="min-w-0">
                <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#1a2555] mb-1">Board</label>
                <select name="board" className={inputCls("board")} data-testid="ug-select-board">
                  <option value="">Select</option>
                  <option>ICSE</option><option>CBSE</option><option>IB</option><option>State Board</option><option>CAIE</option><option>NIOS</option>
                </select>
              </div>
            </div>
            <label className="flex items-start gap-2 text-[12px] text-[#4b5563] mb-3 cursor-pointer">
              <input type="checkbox" name="whatsapp" defaultChecked className="mt-0.5 accent-[#4242FF]" data-testid="ug-checkbox-whatsapp" />
              <span>I wish to receive updates on WhatsApp about the program.</span>
            </label>
            <button type="submit" disabled={submitting} className="w-full py-3 px-5 rounded-full bg-[#4242FF] hover:bg-[#3232e6] text-white text-[15px] font-semibold tracking-tight transition-all hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none" data-testid="ug-submit-btn">
              {submitting ? "Submitting…" : "Submit Interest"}
            </button>
            <p className="text-[11px] text-[#8a8fa3] text-center mt-2.5 leading-relaxed">By submitting, you agree to receive communication about Bower School programs.</p>
          </form>
        </>
      ) : (
        <div className="text-center py-10 px-3" data-testid="ug-form-success">
          <div className="w-14 h-14 rounded-full bg-[rgba(66,66,255,0.12)] flex items-center justify-center mx-auto mb-3 text-[#4242FF]">
            <Check size={28} />
          </div>
          <h4 className="text-xl font-bold text-[#1a2555] mb-1.5">Interest Received!</h4>
          <p className="text-sm text-[#6a6a6a]">Our admissions team will reach out shortly.</p>
        </div>
      )}
    </div>
  );
}

// Mentor auto-scroll marquee
function MentorsCarousel() {
  // Duplicate list for seamless infinite scroll
  const list = [...MENTORS, ...MENTORS];
  return (
    <section className="w-full px-4 py-14 md:py-20 lg:px-20 bg-gradient-to-br from-[#010817] to-black overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        <Reveal className="text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-white mb-3 tracking-[-1.76px]">Meet Our Practitioners</h2>
          <p className="text-base md:text-lg text-gray-300 max-w-3xl mx-auto">Get to know the people who make Bower what it is, and what it&rsquo;s becoming.</p>
        </Reveal>
        <div className="relative">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 z-10 bg-gradient-to-r from-[#010817] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 z-10 bg-gradient-to-l from-black to-transparent" />
          <div className="ug-marquee overflow-hidden max-w-full">
            <div className="ug-marquee-track">
              {list.map((m, i) => (
                <div key={i} className="ug-mentor-card" data-testid={`ug-mentor-${i}`}>
                  <div className="relative h-[380px] rounded-2xl overflow-hidden bg-gray-900">
                    <img src={m.img} alt={m.name} loading="lazy" className="w-full h-full object-cover grayscale" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-2">
                      <div className="backdrop-blur-xl rounded-xl px-4 py-3 border border-white/20 bg-gradient-to-br from-[rgba(66,66,255,0.2)] to-[rgba(50,50,230,0.2)]">
                        <h3 className="text-lg font-bold text-white leading-tight">{m.name}</h3>
                        <p className="text-sm text-gray-300 line-clamp-2 mt-1">{m.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// Video player w/ YouTube modal
function VideoBanner({ onPlay }) {
  return (
    <section className="w-full px-4 md:px-10 lg:px-20 py-10 md:py-14 bg-[#f4f4ff]">
      <div className="max-w-[1280px] mx-auto">
        <div className="relative w-full rounded-2xl md:rounded-3xl overflow-hidden bg-white shadow-[4px_4px_24px_0px_rgba(0,0,0,0.06)] border border-white">
          <div className="absolute inset-0">
            <img src="https://bowerschool.com/2fda539e10baec0e450de6636564b28e083dce65.svg" alt="" className="w-full h-full object-cover" />
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row gap-6 md:gap-10 lg:gap-16 items-center p-5 md:p-8 lg:p-10">
            <div className="w-full lg:w-[342px] flex flex-col justify-center">
              <div className="text-center lg:text-left">
                <h3 className="text-[22px] md:text-[26px] lg:text-[30px] font-semibold text-gray-900 tracking-[-0.96px] mb-3">Build. Lead. Innovate.</h3>
                <p className="text-sm md:text-base lg:text-lg text-gray-600">Begin your entrepreneurial journey with our 3-year Undergraduate Program in Entrepreneurship.</p>
              </div>
            </div>
            <button
              onClick={onPlay}
              className="relative w-full lg:flex-1 h-[240px] md:h-[340px] lg:h-[420px] rounded-xl md:rounded-2xl overflow-hidden group cursor-pointer border-4 md:border-8 border-white"
              style={{ backgroundImage: `url('${VIDEO_POSTER}')`, backgroundSize: "cover", backgroundPosition: "center" }}
              data-testid="ug-video-play-btn"
              aria-label="Play program video"
            >
              <div className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors" />
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-[#3232e6]/60 backdrop-blur border border-white/40 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <div className="absolute inset-0 rounded-2xl bg-[#3232e6]/50 animate-ping" />
                  <Play size={40} className="text-white fill-white relative z-10 ml-1" />
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

// ===== Curriculum with Year tabs =====
function CurriculumSection() {
  const [activeYear, setActiveYear] = useState(0);
  const [openSemester, setOpenSemester] = useState(0);
  const year = YEAR_CURRICULUM[activeYear];
  return (
    <section className="w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 bg-[#f4f4ff]" data-testid="ug-curriculum-section">
      <div className="max-w-[1280px] mx-auto">
        <Reveal className="mb-8 md:mb-10 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-[#1a2555] mb-2 tracking-[-1.76px]">Bower&rsquo;s Curriculum</h2>
          <p className="text-base md:text-lg text-[#4b5563]">Foundations that power entrepreneurial success.</p>
        </Reveal>

        <Reveal delay={100}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
            <div className="inline-flex bg-white rounded-full p-1.5 shadow-md border border-slate-200">
              {YEAR_CURRICULUM.map((y, i) => (
                <button
                  key={y.year}
                  onClick={() => { setActiveYear(i); setOpenSemester(0); }}
                  className={`px-5 md:px-6 py-2 rounded-full text-sm font-semibold transition-all ${activeYear === i ? "bg-[#4242FF] text-white shadow-[0_6px_16px_rgba(66,66,255,0.35)]" : "text-[#1a2555] hover:bg-slate-100"}`}
                  data-testid={`ug-year-tab-${i}`}
                >
                  {y.year}
                </button>
              ))}
            </div>
            <button className="inline-flex items-center gap-2 text-sm font-semibold text-[#4242FF] hover:text-[#3232e6] transition-colors" data-testid="ug-curriculum-download" onClick={() => window.open("https://bowerschool-website.blr1.cdn.digitaloceanspaces.com/assets/pdf/new/ug-2026.pdf", "_blank", "noopener,noreferrer")}>
              <Download size={16} /> Download Full Brochure
            </button>
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="rounded-2xl md:rounded-3xl overflow-hidden border border-[rgba(66,66,255,0.25)] bg-white shadow-[0_20px_60px_-20px_rgba(66,66,255,0.25)]">
            <div className="px-6 md:px-8 py-6 md:py-7 border-b border-slate-100 bg-gradient-to-r from-[#4242FF] to-[#3232e6] text-white flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/20 border border-white/30 flex items-center justify-center flex-shrink-0">
                <GraduationCap size={20} />
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-widest opacity-80">{year.year}</div>
                <h3 className="text-lg md:text-2xl font-semibold tracking-tight">{year.title}</h3>
              </div>
            </div>
            <div className="p-4 md:p-6">
              {year.semesters.map((sem, si) => {
                const open = openSemester === si;
                return (
                  <div key={sem.name} className={`rounded-xl border ${open ? "border-[rgba(66,66,255,0.5)]" : "border-slate-200"} mb-3 last:mb-0 overflow-hidden bg-[#fafaff]`}>
                    <button
                      className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left"
                      onClick={() => setOpenSemester(open ? -1 : si)}
                      data-testid={`ug-semester-toggle-${si}`}
                    >
                      <span className="text-base md:text-lg font-semibold text-[#1a2555]">{sem.name}</span>
                      <ChevronDown size={20} className={`text-[#4242FF] transition-transform ${open ? "rotate-180" : ""}`} />
                    </button>
                    {open && (
                      <div className="px-5 md:px-6 pb-5 md:pb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                        {sem.blocks.map((b) => (
                          <div key={b.title} className="rounded-lg border border-slate-200 bg-white p-4">
                            <div className="text-[11px] uppercase tracking-widest text-[#4242FF] font-bold mb-2">{b.title}</div>
                            <ul className="space-y-1.5">
                              {b.items.map((item) => (
                                <li key={item} className="flex items-start gap-2 text-sm text-[#374151]">
                                  <span className="mt-1 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-[#4242FF]" />
                                  <span>{item}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

// ===== Founders Learn Faster =====
function FoundersLearnFaster() {
  return (
    <section className="relative w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 overflow-hidden" style={{ background: "linear-gradient(135deg, #010817 0%, #0a0f2e 60%, #1a1acc 130%)" }}>
      <div className="pointer-events-none absolute -top-40 -right-20 w-[520px] h-[520px] rounded-full opacity-30" style={{ background: "radial-gradient(circle, rgba(66,66,255,0.6), transparent 60%)" }} />
      <div className="relative max-w-[1280px] mx-auto text-center">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/20 bg-white/5 text-[11px] uppercase tracking-widest text-white/80 mb-5">
            <Users size={12} /> Community
          </div>
          <h2 className="text-white text-3xl md:text-4xl lg:text-[52px] font-bold leading-[1.15] tracking-[-2px] mb-3">Founders Learn Faster <span style={{ color: "#7A7AFF" }}>Together</span></h2>
          <p className="text-white/70 text-base md:text-lg mb-10">Join 10K+ others taking the leap.</p>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {FOUNDER_STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 100}>
              <div className="rounded-2xl p-6 md:p-8 border border-white/15 backdrop-blur-md" style={{ background: "linear-gradient(155deg, rgba(66,66,255,0.15) 0%, rgba(10,10,40,0.4) 100%)" }}>
                <div className="text-[42px] md:text-[56px] font-bold text-white mb-1 tracking-[-2px]">{s.value}</div>
                <div className="text-white/70 text-sm md:text-base font-medium">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== Founder Skills =====
function FounderSkillsSection() {
  return (
    <section className="w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 bg-[#f4f4ff]" data-testid="ug-skills-section">
      <div className="max-w-[1280px] mx-auto">
        <Reveal className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#4242FF]/10 text-[#4242FF] text-[11px] uppercase tracking-widest font-semibold mb-4">A Pro</div>
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-[#1a2555] tracking-[-1.76px]">Founder&rsquo;s skills that matter</h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {FOUNDER_SKILLS.map((s, i) => (
            <Reveal key={s.title} delay={i * 80}>
              <div className="group h-full rounded-2xl p-6 md:p-7 bg-white border border-slate-200 hover:border-[#4242FF]/40 hover:-translate-y-1 hover:shadow-[0_20px_40px_-15px_rgba(66,66,255,0.35)] transition-all">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#4242FF] to-[#3232e6] flex items-center justify-center text-white mb-4 shadow-[0_8px_20px_rgba(66,66,255,0.35)]">
                  <s.icon size={22} />
                </div>
                <h3 className="text-xl font-semibold text-[#1a2555] mb-2 tracking-tight">{s.title}</h3>
                <p className="text-sm text-[#4b5563] leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== Tools you will master =====
function ToolsMastered() {
  const list = [...TOOLS, ...TOOLS];
  return (
    <section className="w-full py-14 md:py-20 bg-white overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-4 md:px-10 lg:px-20">
        <Reveal className="text-center mb-8 md:mb-10">
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-[#1a2555] tracking-[-1.76px] mb-2">Tools you will master</h2>
          <p className="text-base md:text-lg text-[#4b5563]">Industry-grade tools you&rsquo;ll ship with, from Day 1.</p>
        </Reveal>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 z-10 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 z-10 bg-gradient-to-l from-white to-transparent" />
        <div className="ug-tools-marquee">
          <div className="ug-tools-track">
            {list.map((t, i) => (
              <div key={i} className="ug-tool-chip" data-testid={`ug-tool-${i}`}>
                <img src={t.img} alt={t.name} loading="lazy" className="w-10 h-10 md:w-12 md:h-12 object-contain" />
                <span className="text-xs md:text-sm text-[#374151] font-medium mt-2 whitespace-nowrap">{t.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ===== You After Bower's Camp =====
function YouAfterBower() {
  return (
    <section className="relative w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 overflow-hidden" style={{ background: "linear-gradient(135deg, #010817 0%, #0f0f3d 100%)" }}>
      <div className="pointer-events-none absolute -top-40 -left-20 w-[520px] h-[520px] rounded-full opacity-30" style={{ background: "radial-gradient(circle, rgba(66,66,255,0.5), transparent 60%)" }} />
      <div className="relative max-w-[1200px] mx-auto">
        <Reveal className="text-center mb-10 md:mb-14">
          <h2 className="text-white text-3xl md:text-4xl lg:text-[52px] font-bold leading-[1.15] tracking-[-2px] mb-3">You After Bower&rsquo;s Camp</h2>
          <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto">Here&rsquo;s a snapshot of what a Bower graduate looks like — skills, projects, and portfolio.</p>
        </Reveal>
        <Reveal delay={150}>
          <div className="rounded-2xl md:rounded-3xl overflow-hidden border border-white/15 backdrop-blur-md" style={{ background: "linear-gradient(155deg, rgba(66,66,255,0.15) 0%, rgba(10,10,40,0.6) 100%)" }}>
            <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr]">
              <div className="p-6 md:p-8 border-b lg:border-b-0 lg:border-r border-white/10 flex flex-col items-center text-center">
                <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden mb-4 border-2 border-white/20">
                  <img src="https://bowerschool.com/d7a2a0d550a20c2a914b7ac43e7753570ce97577.png" alt="Aryan Valluri" className="w-full h-full object-cover" loading="lazy" />
                </div>
                <h3 className="text-white text-2xl font-semibold mb-1">Aryan Valluri</h3>
                <div className="text-[#a5a5ff] text-sm mb-2">Young Entrepreneur</div>
                <div className="text-white/60 text-xs mb-4">Bower School of Entrepreneurship · Undergraduate</div>
                <div className="flex gap-2">
                  <span className="w-9 h-9 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-white/80"><Instagram size={16} /></span>
                </div>
              </div>
              <div className="p-6 md:p-8">
                <div className="mb-6">
                  <div className="text-[11px] uppercase tracking-widest text-[#a5a5ff] font-bold mb-3">Projects</div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {["Build your own food-truck simulation", "&ldquo;Fix the Planet&rdquo; group pitch", "My first Pet-Tracker app", "1-minute Logo Maker"].map((p, i) => (
                      <div key={i} className="flex items-start gap-2 rounded-lg bg-white/5 border border-white/10 px-3 py-2">
                        <Check size={14} className="text-[#7A7AFF] mt-1 flex-shrink-0" />
                        <span className="text-white/85 text-sm" dangerouslySetInnerHTML={{ __html: p }} />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <div className="text-[11px] uppercase tracking-widest text-[#a5a5ff] font-bold mb-3">Hard Skills</div>
                    <div className="flex flex-wrap gap-2">
                      {["Creative Skills", "Basic Coding", "Design Thinking", "Figma", "Spreadsheet Fluency", "HTML"].map((t) => (
                        <span key={t} className="text-xs md:text-sm px-3 py-1.5 rounded-full bg-[#4242FF]/20 border border-[#4242FF]/40 text-white">{t}</span>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className="text-[11px] uppercase tracking-widest text-[#a5a5ff] font-bold mb-3">Soft Skills</div>
                    <div className="flex flex-wrap gap-2">
                      {["Teamwork", "Problem Solving", "Time Management", "Project Management", "Collaboration", "Public Speaking"].map((t) => (
                        <span key={t} className="text-xs md:text-sm px-3 py-1.5 rounded-full bg-white/8 border border-white/20 text-white/85">{t}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

// ===== Bower At a Glimpse =====
function BowerGlimpse() {
  const row1 = GLIMPSE_IMAGES.slice(0, 6);
  const row2 = GLIMPSE_IMAGES.slice(4).concat(GLIMPSE_IMAGES.slice(0, 4));
  return (
    <section className="w-full py-14 md:py-20 bg-white overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 lg:px-20 mb-8 md:mb-10">
        <Reveal className="text-center">
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-[#1a2555] tracking-[-1.76px] mb-2">Bower At a Glimpse</h2>
          <p className="text-base md:text-lg text-[#4b5563] max-w-2xl mx-auto">A quick look at what makes Bower a launchpad for future founders, innovators, and changemakers.</p>
        </Reveal>
      </div>
      <div className="space-y-4">
        {[
          { list: [...row1, ...row1], dir: "left" },
          { list: [...row2, ...row2], dir: "right" },
        ].map((row, ri) => (
          <div key={ri} className="relative">
            <div className={`ug-glimpse-marquee ug-glimpse-${row.dir} overflow-hidden max-w-full`}>
              <div className="ug-glimpse-track">
                {row.list.map((src, i) => (
                  <div key={i} className="ug-glimpse-card">
                    <img src={src} alt="Bower campus" loading="lazy" className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ===== Student Ventures =====
function StudentVentures() {
  const [idx, setIdx] = useState(0);
  const next = () => setIdx((i) => (i + 1) % STUDENT_VENTURES.length);
  const prev = () => setIdx((i) => (i - 1 + STUDENT_VENTURES.length) % STUDENT_VENTURES.length);
  const v = STUDENT_VENTURES[idx];
  return (
    <section className="relative w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 overflow-hidden" style={{ background: "linear-gradient(135deg, #010817 0%, #1a1a3a 100%)" }} data-testid="ug-ventures-section">
      <div className="relative max-w-[1200px] mx-auto">
        <Reveal className="text-center mb-10 md:mb-12">
          <h2 className="text-white text-3xl md:text-4xl lg:text-[52px] font-bold leading-[1.15] tracking-[-2px]">Our UG Student <span style={{ color: "#7A7AFF" }}>Ventures</span></h2>
        </Reveal>
        <Reveal delay={100}>
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden border border-white/15 backdrop-blur-md" style={{ background: "linear-gradient(155deg, rgba(66,66,255,0.15) 0%, rgba(10,10,40,0.5) 100%)" }}>
            <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-6 md:gap-8 p-6 md:p-10">
              <div className="flex justify-center md:justify-start">
                <div className="w-40 h-40 md:w-56 md:h-56 rounded-2xl overflow-hidden border-2 border-white/20">
                  <img src={v.img} alt={v.name} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="flex flex-col justify-center">
                <div className="text-[48px] md:text-[80px] leading-none text-[#7A7AFF] mb-2 font-serif">&ldquo;</div>
                <p className="text-white/85 text-base md:text-lg leading-relaxed mb-5">{v.quote}</p>
                <div>
                  <h4 className="text-white text-lg md:text-xl font-semibold">{v.name}</h4>
                  <div className="text-[#a5a5ff] text-sm">{v.role}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center gap-4 mt-6">
            <button onClick={prev} className="w-11 h-11 rounded-full border border-white/25 bg-white/5 hover:bg-white/10 text-white flex items-center justify-center transition-colors" aria-label="Previous" data-testid="ug-ventures-prev">
              <ChevronLeft size={20} />
            </button>
            <div className="flex items-center gap-2">
              {STUDENT_VENTURES.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} className={`w-2 h-2 rounded-full transition-all ${i === idx ? "bg-[#7A7AFF] w-6" : "bg-white/30"}`} aria-label={`Slide ${i + 1}`} />
              ))}
            </div>
            <button onClick={next} className="w-11 h-11 rounded-full border border-white/25 bg-white/5 hover:bg-white/10 text-white flex items-center justify-center transition-colors" aria-label="Next" data-testid="ug-ventures-next">
              <ChevronRight size={20} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

// ===== Application Process & Eligibility =====
function ApplicationProcessSection() {
  return (
    <section className="w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 bg-[#f4f4ff]" data-testid="ug-application-section">
      <div className="max-w-[1280px] mx-auto">
        <Reveal className="text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-[#1a2555] tracking-[-1.76px]">Application Process &amp; Eligibility</h2>
        </Reveal>
        {/* Rounds table */}
        <Reveal delay={100}>
          <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-[0_10px_40px_-15px_rgba(66,66,255,0.2)] mb-10 md:mb-14 bg-white">
            <div className="hidden md:grid grid-cols-4 bg-[#1a2555] text-white text-xs uppercase tracking-widest font-semibold">
              <div className="px-6 py-4">Rounds</div>
              <div className="px-6 py-4">Deadlines</div>
              <div className="px-6 py-4">Cohort Commencement</div>
              <div className="px-6 py-4">Status</div>
            </div>
            {APPLICATION_ROUNDS.map((r) => (
              <div key={r.round} className="grid grid-cols-2 md:grid-cols-4 gap-y-2 md:gap-0 px-4 md:px-0 py-4 md:py-0 border-t border-slate-100 items-center">
                <div className="md:hidden text-[11px] uppercase text-slate-500 font-semibold">Round</div>
                <div className="md:px-6 md:py-5 font-semibold text-[#1a2555]">{r.round}</div>
                <div className="md:hidden text-[11px] uppercase text-slate-500 font-semibold">Deadline</div>
                <div className="md:px-6 md:py-5 text-[#374151]">{r.deadline}</div>
                <div className="md:hidden text-[11px] uppercase text-slate-500 font-semibold">Cohort</div>
                <div className="md:px-6 md:py-5 text-[#374151]">{r.start}</div>
                <div className="md:hidden text-[11px] uppercase text-slate-500 font-semibold">Status</div>
                <div className="md:px-6 md:py-5">
                  {r.status === "Apply now" ? (
                    <a href="#ug-form" className="inline-flex items-center gap-1.5 text-sm font-semibold px-3 py-1.5 rounded-full bg-[#4242FF] text-white hover:bg-[#3232e6] transition-colors" data-testid="ug-apply-round-btn">
                      Apply now <ArrowRight size={14} />
                    </a>
                  ) : (
                    <span className="inline-flex text-sm font-semibold px-3 py-1.5 rounded-full bg-slate-100 text-slate-500">{r.status}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 4-step process */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {APPLICATION_STEPS.map((step, i) => (
            <Reveal key={step.title} delay={i * 100}>
              <div className="relative h-full rounded-2xl p-6 bg-white border border-slate-200 hover:border-[#4242FF]/40 hover:-translate-y-1 transition-all">
                <div className="absolute -top-4 left-6 w-10 h-10 rounded-xl bg-gradient-to-br from-[#4242FF] to-[#3232e6] text-white flex items-center justify-center font-bold shadow-[0_8px_16px_rgba(66,66,255,0.35)]">
                  {i + 1}
                </div>
                <h3 className="text-lg font-semibold text-[#1a2555] mb-2 mt-4 tracking-tight">{step.title}</h3>
                <p className="text-sm text-[#4b5563] leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== Fee Structure =====
function FeeStructureSection() {
  return (
    <section className="w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 bg-white" data-testid="ug-fee-section">
      <div className="max-w-[900px] mx-auto">
        <Reveal className="text-center mb-8 md:mb-10">
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-[#1a2555] tracking-[-1.76px] mb-2">Course Fee Structure</h2>
          <p className="text-base md:text-lg text-[#4b5563]">Transparent, all-inclusive fee — with 7 exclusive scholarships available.</p>
        </Reveal>
        <Reveal delay={100}>
          <div className="rounded-2xl overflow-hidden border border-slate-200 bg-white shadow-[0_10px_40px_-15px_rgba(66,66,255,0.2)]">
            <div className="grid grid-cols-2 bg-[#1a2555] text-white text-xs uppercase tracking-widest font-semibold">
              <div className="px-6 py-4">Year</div>
              <div className="px-6 py-4 text-right">Course Fee</div>
            </div>
            {FEE_STRUCTURE.map((r) => (
              <div key={r.year} className="grid grid-cols-2 border-t border-slate-100">
                <div className="px-6 py-4 text-[#1a2555] font-medium">{r.year}</div>
                <div className="px-6 py-4 text-right text-[#374151]">{r.fee}</div>
              </div>
            ))}
            <div className="grid grid-cols-2 bg-[#f4f4ff] border-t-2 border-[#4242FF]">
              <div className="px-6 py-4 text-[#1a2555] font-bold">{FEE_TOTAL.year}</div>
              <div className="px-6 py-4 text-right text-[#4242FF] font-bold text-lg">{FEE_TOTAL.fee}</div>
            </div>
          </div>
          <p className="text-center text-xs text-[#8a8fa3] mt-4">*All fees exclusive of applicable taxes. Scholarships up to 100% available based on BEAT score and interview.</p>
        </Reveal>
      </div>
    </section>
  );
}

// ===== FAQ =====
function FAQSection() {
  const [catIdx, setCatIdx] = useState(0);
  const [openIdx, setOpenIdx] = useState(0);
  const items = FAQ_CATEGORIES[catIdx].items;
  return (
    <section className="w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 bg-[#f4f4ff]" data-testid="ug-faq-section">
      <div className="max-w-[1100px] mx-auto">
        <Reveal className="text-center mb-8 md:mb-10">
          <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold text-[#1a2555] tracking-[-1.76px] mb-2">Frequently Asked Questions</h2>
          <p className="text-base md:text-lg text-[#4b5563]">Everything you need to know before applying.</p>
        </Reveal>
        <Reveal delay={100}>
          <div className="flex flex-wrap items-center justify-center gap-2 mb-6">
            {FAQ_CATEGORIES.map((c, i) => (
              <button
                key={c.name}
                onClick={() => { setCatIdx(i); setOpenIdx(0); }}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${catIdx === i ? "bg-[#4242FF] text-white shadow-[0_6px_16px_rgba(66,66,255,0.35)]" : "bg-white text-[#1a2555] hover:bg-slate-100 border border-slate-200"}`}
                data-testid={`ug-faq-cat-${i}`}
              >
                {c.name}
              </button>
            ))}
          </div>
        </Reveal>
        <Reveal delay={150}>
          <div className="space-y-3">
            {items.map((item, i) => {
              const open = openIdx === i;
              return (
                <div key={item.q} className={`rounded-xl border ${open ? "border-[rgba(66,66,255,0.5)] bg-white" : "border-slate-200 bg-white"} overflow-hidden`}>
                  <button
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    data-testid={`ug-faq-item-${i}`}
                  >
                    <div className="flex items-start gap-4">
                      <span className="text-[11px] font-bold text-[#4242FF] mt-1">{String(i + 1).padStart(2, "0")}</span>
                      <span className="text-base md:text-lg font-semibold text-[#1a2555] tracking-tight">{item.q}</span>
                    </div>
                    <ChevronDown size={20} className={`text-[#4242FF] flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
                  </button>
                  {open && (
                    <div className="px-5 md:px-6 pb-5 md:pb-6 pl-12 md:pl-14">
                      <p className="text-sm md:text-base text-[#4b5563] leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}


export default function UGProgramPage() {
  const [videoOpen, setVideoOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = () => {
    const t = document.getElementById("ug-form");
    if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }} data-testid="ug-program-page">
      {/* ===== Header ===== */}
      <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "bg-black/70 backdrop-blur-md shadow-lg" : "bg-black/40 backdrop-blur-sm"}`} data-testid="ug-header">
        <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-3 flex items-center justify-between">
          <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer">
            <img src={BOWER_LOGO} alt="Bower School of Entrepreneurship" className="h-8 md:h-10 w-auto" />
          </a>
          <button onClick={scrollToForm} className="text-sm font-semibold text-white bg-[#4242FF] hover:bg-[#3232e6] rounded-full px-5 md:px-6 py-2 md:py-2.5 transition-all hover:-translate-y-0.5" data-testid="ug-header-enquire-btn">
            Enquire Now
          </button>
        </div>
      </header>

      <main className="flex-1">
        {/* ===== HERO ===== */}
        <section className="relative w-full pb-8 md:pb-12 bg-[#04041a]" data-testid="ug-hero-section">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute inset-0" style={{ backgroundImage: `url('${HERO_BG}')`, backgroundSize: "cover", backgroundPosition: "center" }} />
            <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(4,4,20,0.6) 45%, rgba(4,4,25,0.9) 85%, #04041a 100%)" }} />
          </div>
          <div className="relative z-10 max-w-[1440px] mx-auto px-4 md:px-10 lg:px-20 pt-14 md:pt-16 lg:pt-20">
            <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_1fr] gap-9 lg:gap-14 items-start">
              <Reveal className="min-w-0 text-center lg:text-left">
                <h1 className="font-bold text-[#f5f9ff] leading-[1.12] tracking-[-2px] mb-4 md:mb-5" style={{ fontSize: "clamp(30px,6.5vw,58px)" }} data-testid="ug-hero-headline">
                  Graduate as an Entrepreneur with Mindset, Skills &amp; a Venture
                </h1>
                <p className="text-white/85 max-w-[560px] mx-auto lg:mx-0 leading-relaxed" style={{ fontSize: "clamp(15px,2vw,19px)" }}>
                  India&rsquo;s only 3-year undergraduate BBA built entirely around entrepreneurship &mdash; practitioner-led teaching, startup incubation, 100+ mentors, and real venture building at Bower School, Hyderabad.
                </p>
                <div className="hidden lg:flex gap-3 mt-6">
                  <button onClick={scrollToForm} className="bg-white text-[#1a2555] font-semibold px-6 py-3 rounded-full text-sm hover:-translate-y-0.5 transition-all inline-flex items-center gap-2" data-testid="ug-hero-cta-primary">
                    Apply Now <ArrowRight size={16} />
                  </button>
                </div>
              </Reveal>
              <Reveal delay={150} className="min-w-0">
                <InterestForm />
              </Reveal>
            </div>

            {/* Info bar */}
            <Reveal delay={200} className="mt-10 md:mt-12">
              <div className="rounded-2xl px-4 md:px-8 py-4 md:py-5 border bg-[#f5f6ff] border-[rgba(66,66,255,0.4)] shadow-[8px_8px_24px_0px_rgba(66,66,255,0.08)] flex flex-col md:flex-row items-center gap-4 md:gap-8">
                <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                  {[
                    { label: "Round-3 deadline", value: "July 19, 2026", icon: Calendar },
                    { label: "Duration", value: "3 Years", icon: Clock },
                    { label: "Location", value: "Hyderabad", icon: MapPin },
                    { label: "Cohort Starts from", value: "August, 2026", icon: Calendar },
                  ].map((item, i) => (
                    <div key={i} className="flex flex-col gap-1 text-left md:border-l md:first:border-l-0 md:pl-4 md:first:pl-0" style={{ borderColor: "#d5d7e8" }}>
                      <span className="text-[11px] md:text-[13px] text-[#6a6a6a] flex items-center gap-1.5">
                        <item.icon size={12} /> {item.label}
                      </span>
                      <span className="text-[16px] md:text-[20px] lg:text-[22px] font-semibold text-[#1a2555] tracking-[-0.8px]">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== Stats ===== */}
        <section className="relative py-14 md:py-20 bg-[#f0f0ff] overflow-hidden">
          <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row gap-10 md:gap-16 items-center">
              <Reveal className="flex-1 flex items-center justify-center min-w-0 w-full">
                <img src={BREAKUP_CIRCLE} alt="Bower School program impact statistics" loading="lazy" className="w-full max-w-[560px] md:max-w-[640px] lg:max-w-[720px] h-auto object-contain" />
              </Reveal>
              <Reveal delay={150} className="flex-1 w-full max-w-[600px] min-w-0">
                <div className="rounded-2xl p-5 md:p-8 shadow-xl border border-white/40 bg-white/50 backdrop-blur-md">
                  {STATS.map((s, i) => (
                    <div key={i} className={`py-6 md:py-7 ${i < STATS.length - 1 ? "border-b border-slate-200" : ""}`}>
                      <div className="text-[32px] md:text-[42px] lg:text-[48px] font-semibold text-[#2d2d2d] mb-2 md:mb-3">{s.value}</div>
                      <div className="text-[17px] md:text-[20px] font-semibold text-[#161616] mb-1.5">{s.title}</div>
                      <div className="text-sm md:text-base text-[#5a5a5a] leading-relaxed">{s.desc}</div>
                    </div>
                  ))}
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* ===== Why Bower ===== */}
        <section className="relative w-full overflow-hidden py-14 md:py-20 lg:py-24" style={{ backgroundColor: "#010817", backgroundImage: "radial-gradient(ellipse at center bottom, rgba(66, 66, 255, 0.15) 0%, rgba(50, 50, 230, 0.05) 51%, transparent 100%)" }}>
          <div className="relative max-w-[1440px] mx-auto px-4 md:px-10 lg:px-20">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <Reveal className="flex-1 min-w-0">
                <h2 className="text-4xl md:text-5xl lg:text-[72px] font-bold leading-[1.1] tracking-[-2px] md:tracking-[-3px] lg:tracking-[-4px]">
                  <span className="text-white">Why is Bower the</span><br />
                  <span style={{ color: "#4242FF" }}>right place?</span>
                </h2>
                <p className="mt-5 md:mt-6 text-base md:text-lg lg:text-xl text-white/80 leading-relaxed max-w-md">
                  Entrepreneurship is not just a career, it&rsquo;s a mindset. At Bower, we prepare you to thrive in a fast-changing world through:
                </p>
              </Reveal>
              <div className="flex-1 flex flex-col gap-5 md:gap-6">
                {WHY_BOWER.map((card, i) => (
                  <Reveal key={i} delay={i * 100}>
                    <div
                      className="relative w-full md:w-[420px] lg:w-[460px] rounded-2xl px-6 md:px-8 py-5 md:py-6 backdrop-blur-md hover:scale-[1.02] transition-transform"
                      style={{
                        transform: `rotate(${card.tilt}deg)`,
                        backgroundImage: "linear-gradient(to top, rgba(66, 66, 255, 0.25), rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
                        border: "1px solid rgba(248, 242, 255, 0.2)",
                      }}
                    >
                      <div className="absolute top-4 right-5 text-[50px] md:text-[70px] font-bold text-white/10 tracking-[-2px] leading-none">
                        {String(i + 1).padStart(2, "0")}
                      </div>
                      <card.icon size={28} className="text-white/70 mb-3" />
                      <h3 className="text-[19px] md:text-[22px] font-semibold text-[#fbfff3] tracking-[-0.88px] mb-2 pr-12">{card.title}</h3>
                      <p className="text-[14px] md:text-[15px] text-[#fbfff3] leading-relaxed pr-12">{card.desc}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ===== Video Banner ===== */}
        <VideoBanner onPlay={() => setVideoOpen(true)} />

        {/* ===== Curriculum comparison ===== */}
        <section className="relative w-full px-4 md:px-10 lg:px-20 py-14 md:py-20 overflow-hidden" style={{ backgroundColor: "#252525" }}>
          <div className="relative z-10 max-w-[1440px] mx-auto">
            <Reveal className="mb-10">
              <h2 className="text-white capitalize mb-2 text-[28px] md:text-[36px] lg:text-[44px] font-semibold leading-tight tracking-[-1.76px]">
                Education is Evolving&mdash;And It&rsquo;s Time We Did Too.
              </h2>
              <p className="text-[#aaaab9] text-base md:text-lg lg:text-xl leading-relaxed">
                We&rsquo;re not just following the old playbook&mdash;we&rsquo;re rewriting it for today&rsquo;s learners.
              </p>
            </Reveal>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5 items-stretch">
              <Reveal className="h-full">
                <div className="rounded-2xl lg:rounded-3xl p-5 md:p-6 border border-white/10 bg-[#1a1a1a] h-full flex flex-col">
                  <div className="min-h-[64px] flex items-center justify-between mb-6 md:mb-8">
                    <h3 className="text-[#f0f0ff] text-[22px] md:text-[26px] lg:text-[28px] font-semibold leading-tight tracking-[-1.2px]">Regular School Curriculum</h3>
                  </div>
                  <div className="flex flex-col gap-3 flex-1">
                    {CURRICULUM_COMPARISON.map((row, i) => (
                      <div key={i} className="bg-[#232323] rounded-xl p-4 border border-white/10 min-h-[112px] flex flex-col justify-center">
                        <h4 className="text-[#f0f0ff] mb-1.5 text-lg font-medium tracking-tight">{row.old.title}</h4>
                        <p className="text-[#8f8f9a] text-sm leading-relaxed">{row.old.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </Reveal>
              <Reveal delay={150} className="h-full">
                <div
                  className="relative rounded-2xl lg:rounded-3xl p-[1.5px] h-full overflow-hidden"
                  style={{
                    background: "linear-gradient(135deg, #4242FF 0%, #7A7AFF 40%, #4242FF 100%)",
                    boxShadow: "0 0 40px rgba(66,66,255,0.35), 0 20px 60px rgba(66,66,255,0.18)",
                  }}
                >
                  {/* Animated glow behind card */}
                  <div className="pointer-events-none absolute -inset-10 opacity-40 blur-3xl" style={{ background: "radial-gradient(circle at 30% 20%, rgba(122,122,255,0.6), transparent 60%)" }} />
                  <div className="relative rounded-[calc(1rem-1.5px)] lg:rounded-[calc(1.5rem-1.5px)] p-5 md:p-6 h-full flex flex-col"
                    style={{ background: "linear-gradient(155deg, rgba(30,20,80,0.98) 0%, rgba(10,10,40,0.98) 60%, rgba(66,66,255,0.15) 100%)" }}
                  >
                    <div className="min-h-[64px] flex items-center justify-between gap-3 mb-6 md:mb-8">
                      <h3 className="text-white text-[22px] md:text-[26px] lg:text-[28px] font-semibold leading-tight tracking-[-1.2px]">Bower Curriculum</h3>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-[10px] font-semibold uppercase tracking-widest text-white/90 flex-shrink-0">
                        <Sparkles size={11} className="text-[#a5a5ff]" /> The Bower Way
                      </span>
                    </div>
                    <div className="flex flex-col gap-3 flex-1">
                      {CURRICULUM_COMPARISON.map((row, i) => (
                        <div
                          key={i}
                          className="group relative rounded-xl p-4 border border-white/15 overflow-hidden transition-all hover:border-[#7A7AFF]/60 hover:-translate-y-0.5 min-h-[112px] flex flex-col justify-center"
                          style={{ background: "linear-gradient(135deg, rgba(66,66,255,0.18) 0%, rgba(20,20,50,0.6) 100%)" }}
                        >
                          <div className="absolute -left-px top-0 bottom-0 w-[3px] bg-gradient-to-b from-[#7A7AFF] via-[#4242FF] to-transparent" />
                          <div className="flex items-start gap-3">
                            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#4242FF] flex items-center justify-center mt-0.5 shadow-[0_4px_12px_rgba(66,66,255,0.5)]">
                              <Check size={14} className="text-white" strokeWidth={3} />
                            </div>
                            <div className="min-w-0">
                              <h4 className="text-white mb-1.5 text-lg font-semibold tracking-tight">{row.bower.title}</h4>
                              <p className="text-white/75 text-sm leading-relaxed">{row.bower.desc}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* ===== Mentors ===== */}
        <MentorsCarousel />

        {/* ===== Curriculum tabs ===== */}
        <CurriculumSection />

        {/* ===== Founders Learn Faster Together ===== */}
        <FoundersLearnFaster />

        {/* ===== Founder Skills ===== */}
        <FounderSkillsSection />

        {/* ===== Tools you will master ===== */}
        <ToolsMastered />

        {/* ===== You After Bower's Camp ===== */}
        <YouAfterBower />

        {/* ===== Bower At a Glimpse ===== */}
        <BowerGlimpse />

        {/* ===== Student Ventures ===== */}
        <StudentVentures />

        {/* ===== Application Process & Eligibility ===== */}
        <ApplicationProcessSection />

        {/* ===== Course Fee Structure ===== */}
        <FeeStructureSection />

        {/* ===== FAQ ===== */}
        <FAQSection />

        {/* ===== CTA banner ===== */}
        <section className="w-full py-16 md:py-20 px-4 md:px-10 lg:px-20 bg-gradient-to-br from-[#4242FF] via-[#3232e6] to-[#1a1acc] text-white text-center">
          <div className="max-w-3xl mx-auto">
            <Reveal>
              <h2 className="text-3xl md:text-4xl lg:text-[44px] font-bold mb-4 tracking-[-1.6px]">Ready to build your venture?</h2>
              <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed">
                Apply now to the 3-year UG Programme. Round-3 deadline is July 19, 2026.
              </p>
              <button onClick={scrollToForm} className="inline-flex items-center gap-2 bg-white text-[#1a2555] font-semibold px-8 py-3.5 rounded-full text-base hover:-translate-y-0.5 transition-all shadow-lg" data-testid="ug-final-cta-btn">
                Enquire Now <ArrowRight size={18} />
              </button>
            </Reveal>
          </div>
        </section>
      </main>

      {/* Shared Footer */}
      <SharedFooter />

      {/* Video Modal */}
      {videoOpen && (
        <div className="fixed inset-0 z-[100] bg-black/85 flex items-center justify-center p-4 md:p-8" onClick={() => setVideoOpen(false)} data-testid="ug-video-modal">
          <button className="absolute top-4 right-4 md:top-6 md:right-6 text-white bg-white/10 hover:bg-white/20 rounded-full p-2.5 transition-colors" onClick={() => setVideoOpen(false)} aria-label="Close video">
            <X size={22} />
          </button>
          <div className="w-full max-w-5xl aspect-video" onClick={(e) => e.stopPropagation()}>
            <iframe
              className="w-full h-full rounded-xl"
              src={`https://www.youtube.com/embed/${VIDEO_YT_ID}?autoplay=1&rel=0`}
              title="Bower UG Program"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      )}

      {/* Marquee styles moved to index.css for first-paint stability */}
    </div>
  );
}
